import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
    namespaced: true,
    modules: {
        password: require("./password").default,
        qrcode: require("./qrcode").default,
    },
    state: {
        temp: {},
        config: {},
    },
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// src/store/authen/index.js